'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ComponentWithPartials = require('../mixins/ComponentWithPartials');

var _ComponentWithPartials2 = _interopRequireDefault(_ComponentWithPartials);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _immutable = require('immutable');

var _OptionTypes = require('../types/OptionTypes');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UIButton = require('../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIButtonGroup = require('../button/UIButtonGroup');

var _UIButtonGroup2 = _interopRequireDefault(_UIButtonGroup);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _ButtonConstants = require('../button/ButtonConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UIButtonSelectInput = _react2.default.createClass({
  displayName: 'UIButtonSelectInput',

  mixins: [_ComponentWithPartials2.default, _reactAddonsPureRenderMixin2.default],

  propTypes: {
    onChange: _react.PropTypes.func,
    options: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_OptionTypes.OptionType.isRequired).isRequired, _react.PropTypes.instanceOf(_immutable.List).isRequired]).isRequired,
    size: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.SIZE_CLASSES)),
    value: _react.PropTypes.any
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: 'small'
    };
  },
  handleChange: function handleChange(newValue, evt) {
    var _props = this.props,
        onChange = _props.onChange,
        value = _props.value;

    if (newValue === value) {
      return;
    }
    onChange((0, _SyntheticEvent2.default)(newValue, evt));
  },
  renderOption: function renderOption(_ref, option) {
    var size = _ref.size,
        value = _ref.value;

    var isActive = option.value === value;
    return _react2.default.createElement(
      _UITooltip2.default,
      { key: option.value, title: option.title },
      _react2.default.createElement(
        _UIButton2.default,
        {
          active: isActive,
          'aria-checked': isActive,
          className: 'private-button-select-group__option',
          disabled: option.disabled,
          onClick: this.partial(this.handleChange, option.value),
          role: 'radio',
          size: size,
          use: 'tertiary-light'
        },
        option.buttonText || option.text || option.value
      )
    );
  },
  render: function render() {
    var _this = this;

    var _props2 = this.props,
        __onChange = _props2.onChange,
        options = _props2.options,
        size = _props2.size,
        value = _props2.value,
        rest = _objectWithoutProperties(_props2, ['onChange', 'options', 'size', 'value']);

    return _react2.default.createElement(
      _UIButtonGroup2.default,
      _extends({
        className: 'private-button-select-group'
      }, rest, {
        role: 'radiogroup'
      }),
      options.map(function (option) {
        return _this.renderOption({ size: size, value: value }, option);
      })
    );
  }
});

exports.default = (0, _Controllable2.default)(UIButtonSelectInput);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/input/UIButtonSelectInput.js
// module id = 439
// module chunks = 0